import { ArrowRight, ClipboardCheck, History, Link2, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';

export default function Onboarding() {
  const navigate = useNavigate();
  return <div className="onboarding page">
    <Logo />
    <div className="onboarding-visual">
      <div className="sky-orb" />
      <article className="mini-card left"><img src="/images/apartment-warsaw.png" alt="" /><small>Mieszkanie 3 pokoje</small><strong>500 000 zł</strong><em>62 m² · 12 km</em></article>
      <article className="mini-card main"><img src="/images/house-marki.png" alt="" /><small>Dom wolnostojący</small><strong>1 290 000 zł</strong><em>186 m² · 24 km</em></article>
      <article className="mini-card right"><img src="/images/apartment-lodz.png" alt="" /><small>Mieszkanie 2 pokoje</small><strong>420 000 zł</strong><em>45 m² · 8 km</em></article>
      <span className="float-badge badge-tag"><Link2 /></span><span className="float-badge badge-trend"><TrendingUp /></span>
    </div>
    <div className="pager"><i className="active" /><i /><i /></div>
    <div className="onboarding-copy"><h1>Wszystkie oferty<br/><span>w jednym miejscu</span></h1><p>Zapisuj, porównuj i porządkuj duże zakupy z wielu portali — bez chaosu i zbędnego szukania.</p></div>
    <div className="feature-list">
      <div><span className="icon-blue"><Link2 /></span><p><strong>Import z linku lub zdjęcia</strong><small>Dodawaj oferty z dowolnego portalu w kilka sekund.</small></p><ArrowRight /></div>
      <div><span className="icon-green"><History /></span><p><strong>Historia cen i źródeł</strong><small>Sprawdzaj zmiany cen i porównuj wersje.</small></p><ArrowRight /></div>
      <div><span className="icon-orange"><ClipboardCheck /></span><p><strong>Zadania i kolejne kroki</strong><small>Planuj, analizuj i nie zapomnij o niczym ważnym.</small></p><ArrowRight /></div>
    </div>
    <button className="primary-button" onClick={() => navigate('/')}>Rozpocznij <ArrowRight /></button>
    <button className="login-link" onClick={() => navigate('/')}>Mam już konto</button>
  </div>;
}
